module.exports = __webpack_public_path__ + "public/img/bar-2.4666a6a0.png";